import { Directive, ElementRef, inject, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { ADS_TOKEN, AdsProvider, PLATFORM_TOKEN, PlatformProvider } from '../tokens';
import { filter, first, tap } from 'rxjs';
import { BannerAdPluginEvents } from '@capacitor-community/admob';

@Directive({
  standalone: true,
  selector: '[fullHeightScrollableContainer]'
})
export class FullHeightScrollableContainerDirective implements OnInit, OnChanges {
  @Input('fullHeightScrollableContainer') height!: number;

  private readonly adMobBannerHeight: number = 70;
  private readonly iosPlatformOffset: number = 25;

  private readonly elementRef: ElementRef = inject(ElementRef);
  private readonly renderer2: Renderer2 = inject(Renderer2);
  private readonly adsProvider: AdsProvider = inject(ADS_TOKEN);
  private readonly platformProvider: PlatformProvider = inject(PLATFORM_TOKEN);

  ngOnInit(): void {
    this.setStyle();
    this.observeAdBannerEvent();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['height'] && !changes['height'].firstChange) {
      this.setStyle();
    }
  }

  setStyle(additionalValue: number = 0): void {
    const element: ElementRef = this.elementRef.nativeElement;
    const platformOffset: number = this.platformProvider.isiOS ? this.iosPlatformOffset : 0;
    const offsetHeight: number = this.height + additionalValue - platformOffset;

    this.renderer2.setStyle(
      element,
      'height',
      `calc(100vh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px) - ${offsetHeight}px)`
    );
    this.renderer2.setStyle(element, 'overflow-y', 'auto');
  }

  private observeAdBannerEvent(): void {
    this.adsProvider.bannerEvents$
      .pipe(
        filter((event: BannerAdPluginEvents | null) => event === BannerAdPluginEvents.AdImpression),
        first(),
        tap(() => this.setStyle(this.adMobBannerHeight))
      )
      .subscribe();
  }
}
